import React from 'react';
import { Link } from 'react-router-dom';

import { Text } from '../common/atom/Text';
import { Flex } from '../common/atom/Layout';
import { BulletList } from '../common/molecules/BulletList';
import { HorizonLine } from '../common/molecules/HorizonLine';

import { MYPAGE_ORDER_MENU } from '../../lib/routes/MyPageRoutes';
import TEXT from '../../lib/text/textSalesBabyface.json';

const Cancel = () => {
  return (
    <Flex column alignItems="flex-start">
      <Text size={12} weight="medium">
        주문 확인 및 취소, 진행 상황은 로그인 후{' '}
        <Link to={MYPAGE_ORDER_MENU.path}>
          <b>{MYPAGE_ORDER_MENU.label}</b>
        </Link>
        에서 확인해주세요.
      </Text>
      <Flex column alignItems="stretch" padding="1.25rem 0 0">
        {CANCEL_CONTENTS.map((item) => (
          <React.Fragment key={item.title}>
            <HorizonLine text={item.title} />
            <BulletList
              contents={item.contents}
              liStyle={{ fontSize: '0.75rem', listStyleType: 'none' }}
              ulStyle={{
                paddingInlineStart: '1.25rem',
                marginBlockStart: 0,
              }}
            />
          </React.Fragment>
        ))}
      </Flex>
    </Flex>
  );
};

export default Cancel;

const CANCEL_CONTENTS = [
  { title: TEXT.titleRefund, contents: TEXT.notiRefund },
  { title: TEXT.titleAnalyze, contents: TEXT.notiAnalyze },
];
